<template>
  <div class="form_con">
    <top-header :type="6" :placeholder="''" :bgColor="'#fff'" fontSize="0.32rem" />
    <h3>注册方式一：活体实名注册</h3>
    <van-form @submit="onSubmit" validate-trigger="onSubmit">
      <van-field v-model="userName" name="realName" label="姓名" placeholder="请输入姓名" maxlength="10"
        :rules="[{ required: true, message: '请填写姓名' }]" />
      <van-field v-model="idCard" name="cardNo" label="身份证号" placeholder="请输入身份证号" maxlength="18"
        :rules="[{ validator: testIdCard, message: '请填写正确的身份证号' }]" />
      <van-field v-model="phone" type="tel" name="phone" label="手机号" placeholder="请输入手机号"
        :rules="[{ validator: testPhone, message: '请填写正确的手机号' }]">
        <template #button>
          <van-button size="small" type="info" native-type="button" @click="sendCode"
            :disabled="codeTime < 120 ? true : false">{{
              codeTime === 120 ? "发送验证码" : codeTime + "秒后重发"
            }}</van-button>
        </template>
      </van-field>
      <van-field v-model="code" type="number" name="code" label="验证码" maxlength="4" placeholder="请输入短信验证码"
        :rules="[{ required: true, message: '请填写验证码' }]" />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit" :disabled="!checked">
          下一步
        </van-button>
      </div>

      <div class="describe">
        <van-checkbox v-model="checked" icon-size="18px">
          阅读并同意
          <span @click="jumpYH">
            《用户协议》
          </span>
          和
          <span @click="jumpYS">
            《隐私协议》
          </span>
        </van-checkbox>

      </div>
    </van-form>
    <div class="second">
      <h3>注册方式二：人工审核注册</h3>
      <p class="col_red">
        如您通过注册方式一无法成功，可选择注册方式二，人工审核需要一个工作日
      </p>
      <div class="btn_con">
        <router-link to="/registCheck" class="b_btn">人工审核注册</router-link>
      </div>
    </div>
  </div>
</template>

<script>
let timmer = null;
import qs from "qs";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      checked: false,
      userName: "",
      role: "",
      idCard: "",
      phone: "",
      code: "",
      codeTime: 120,
    };
  },
  components: {
    topHeader,
  },
  mounted() { },
  methods: {
    jumpYH() {
      this.$router.push({
        path: "/appCheck"
      });
    },
    jumpYS() {
      this.$router.push({
        path: "/appXieyi"
      });
    },
    testPhone(data) {
      return /^1[3456789]\d{9}$/.test(data);
    },
    testIdCard(data) {
      return /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/.test(
        data
      );
    },
    sendCode() {
      if (!this.userName) {
        this.$toast("请输入姓名");
        return;
      } else if (!this.testIdCard(this.idCard)) {
        this.$toast("请输入正确的身份证号");
        return;
      } else if (!this.testPhone(this.phone)) {
        this.$toast("请输入正确的手机号");
        return;
      }
      if (this.codeTime === 120) {
        this.$http({
          url: "cms/onlineUser/permit/getMessageCodeVerify.do",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            realName: this.userName,
            phone: this.phone,
            cardNo: this.idCard,
          },
        }).then((res) => {
          if (res.success) {
            this.$toast("验证码发送成功，请查收");
            this.codeTime -= 1;
            let setTimer = setInterval(() => {
              if (this.codeTime > 0) {
                this.codeTime -= 1;
              } else {
                this.codeTime = 120;
                clearInterval(setTimer);
              }
            }, 1000);
          } else {
            this.$toast(res.msg);
          }
        });
      }
    },
    // onSubmit(values) {
    //   this.$http({
    //     url: 'cms/onlineUser/permit/createOnlineUserVerifyMobile.do',
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     data: values,
    //   }).then(res => {
    //     if(res.success) {
    //       this.$toast('注册成功');
    //       /* setTimeout(() => {
    //         this.$router.go(-1)
    //       }, 1200);*/
    //       var id = res.obj;
    //       var path = this.$route.path;
    //       this.$router.push({
    //         path: '/testIdCard',
    //         query: {
    //           id,path
    //         }
    //       })
    //     } else {
    //       this.$toast('注册失败')
    //     }
    //   }).catch(() => {
    //       this.$toast('注册失败')
    //   })
    // },
    onSubmit(values) {
      this.$http({
        url: "cms/onlineUser/permit/createOnlineUserVerifyMobileByBaiDu.do",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      })
        .then((res) => {
          if (res.success) {
            var host = window.location.href.split("#")[0];
            // this.$toast(res.msg);
            var id = res.obj;
            window.location.href =
              "https://brain.baidu.com/face/print/?token=" +
              id +
              "&successUrl=" +
              encodeURIComponent(host + "#/transferPage?token=" + id) +
              "&failedUrl=" +
              encodeURIComponent(host + "#/transferFail?token=" + id);
            // this.$router.push({
            //   path: "/transferPage",
            //   query: {
            //     token:id
            //   },
            // });
          } else {
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          this.$toast("注册失败");
        });
    },
    onConfirm(value) {
      this.role = value.text;
      this.showPicker = false;
    },
  },
};
</script>
<style lang="less" scoped>
.describe {
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: #376bff;
  }
}

h3 {
  font-size: 0.36rem;
  font-weight: 800;
  padding: 0 16px;
  margin: 0 auto 0.6rem;
}

.form_con {
  padding: 0.3rem 0rem;
}

.second {
  margin-top: 1.4rem;

  h3 {
    margin-bottom: 0.2rem;
  }

  .col_red {
    font-size: 0.28rem;
    color: #ff3232;
    padding: 0 16px;
    text-indent: 0.48rem;
  }
}

.btn_con {
  // position: fixed;
  padding: 0.35rem;
  background-color: #fff;

  // left: 0;
  // right: 0;
  // bottom: 0;
  .b_btn {
    display: block;
    width: 3.28rem;
    line-height: 0.84rem;
    border-radius: 0.08rem;
    color: #ff3232;
    border: 1px solid currentColor;
    font-size: 0.28rem;
    text-align: center;
    margin: auto;
  }
}
</style>